import {
  List,
  Datagrid,
  TextField,
  EmailField,
  FunctionField,
  EditButton,
  BulkDeleteButton,
  usePermissions,
} from "react-admin";
import { Box, Typography } from "@mui/material";


/* =========================
   PERMISSION LIST
========================= */
export const PermissionList = (props) => {
  const { permissions = [] } = usePermissions();

  return (
    <List title="Permissions" {...props}>
    <Box sx={{ pt: 5, pb: 5 }}>
        <Typography variant="h4" fontWeight={600} align="left">
          Permissions
        </Typography>
      </Box>
      <Datagrid
        bulkActionButtons={
          permissions.includes("permissions.delete")  ||permissions.includes("permissions.*") || permissions.includes("*")
            ? <BulkDeleteButton />
            : false
        }
      >
        <TextField source="id" />
        <TextField source="name" />
        <TextField source="resource" />
        <TextField source="action" />
        <TextField source="description" />

        {(permissions.includes("permissions.edit") ||permissions.includes("permissions.*") || permissions.includes("*")) && (
          <EditButton />
        )}
      </Datagrid>
    </List>
  );
};
